import React from "react";
import { AccountingJsString } from "./AccountingJsString";
import { isZero } from "@travellocal/utils/priceHelpers";

interface IPriceInCurrencyProps extends React.HTMLProps<HTMLSpanElement> {
  priceInCurrency: IPriceInCurrency;
  displayForCustomer?: boolean;
  roundUpToNearest?: number;
}


/**
 * Displays a price in customer and non-customer friendly formats
 *
 * @status stable
 */
export class PriceInCurrency extends React.Component<IPriceInCurrencyProps, {}> {
  static defaultProps = {
    displayForCustomer: true
  }

  render() {
    const { priceInCurrency, displayForCustomer, roundUpToNearest, ref, ...htmlProps } = this.props;

    if (!priceInCurrency) {
      return null;
    }

    let symbol: string;
    if (displayForCustomer) {
      if (!priceInCurrency.currency.availableToCustomers) {
        throw new Error(`Currency ${priceInCurrency.currency.code} is not available to customers`);
      }
      symbol = priceInCurrency.currency.symbol;
    }
    else {
      symbol = priceInCurrency.currency.code;
    }

    return <AccountingJsString
      {...htmlProps}
      price={isZero(priceInCurrency) ? 0 : priceInCurrency.price}
      symbol={symbol}
      formatForCustomer={displayForCustomer}
      precision={priceInCurrency.currency.decimalPlaces}
      roundUpToNearest={roundUpToNearest}
    />
  }
}
